/* eslint-disable */
import React, { useEffect } from 'react';

const RECAPTCHA_ENTERPRISE_URL = 'https://www.google.com/recaptcha/enterprise.js';

type RecaptchaEnterpriseProps = {
  siteKey: string;
  action: string;
  onTokenReceived?: (token: string) => void;
  onExpired?: () => void;
};

const RecaptchaEnterprise = (props: RecaptchaEnterpriseProps) => {
  const { siteKey, action, onTokenReceived, onExpired } = props;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = RECAPTCHA_ENTERPRISE_URL;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window['recaptchaEnterpriseCallback'];
      delete window['recaptchaEnterpriseExpiredCallback'];
    };
  }, []);

  useEffect(() => {
    const handleCallback = (token: string) => {
      onTokenReceived?.(token);
    };

    window['recaptchaEnterpriseCallback'] = handleCallback;
  }, [onTokenReceived]);

  useEffect(() => {
    const handleExpiredCallback = () => {
      onExpired?.();
    };

    window['recaptchaEnterpriseExpiredCallback'] = handleExpiredCallback;
  }, [onExpired]);

  return (
    <div
      className="g-recaptcha"
      data-sitekey={siteKey}
      data-action={action}
      data-callback="recaptchaEnterpriseCallback"
      data-expired-callback="recaptchaEnterpriseExpiredCallback"
    ></div>
  );
};

export default RecaptchaEnterprise;
